import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { TableCellProps, Icon, IconLookup, Tooltip } from 'component-library-and-tools';

import { viewSource } from 'services/source/actionCreators';

const StyledViewSourceContainer = styled.div``;

const StyledIcon = styled(Icon)`
  && {
    font-size: 2rem;
  }
`;

const ViewSourceCell = ({
  value: source,
}: TableCellProps) => {
  const dispatch = useDispatch();

  const handleClick = useCallback((event) => {
    // We stop the propagation of the `click` event to avoid triggering the handler
    // in the table row.
    event.stopPropagation();
    dispatch(viewSource(source));
  }, [source]);

  return (
    <StyledViewSourceContainer>
      <Tooltip content='Source details'>
        <StyledIcon icon={IconLookup.DOCUMENT2} onClick={handleClick} />
      </Tooltip>
    </StyledViewSourceContainer>
  );
};

export default ViewSourceCell;
